module.exports = __webpack_public_path__ + "static/media/brazil.7595e4f2.svg";